/* Great Lakes Lavender Farm - seasonal availability (v3: cottage food pickup requests + All Scents options).
   Seasonal products (Marketing Studio > Seasons) stay on the site all year:
   - out of season: "Back in season <date>" + Notify me, and retail Add to cart / Buy now are hidden
   - approved wholesale buyers can order early in the wholesale window (the app decides)
   - Lavender Passport members (signed in) can order seasonal products a few days early (the app decides; never plants)
   - in season: a small "Available through <date>" note on the product page
   Reads /apps/gllf-content/seasonal (Marketing Studio). Never writes to products, metafields or tags.
   Notify me opens the Saved & Compare (Availability Alerts) email dialog, like the sold-out button. */
(function () {
  'use strict';
  if (window.__gllfSeasonal) return;
  window.__gllfSeasonal = true;

  var API = '/apps/gllf-content/seasonal', CACHE = 'gllf_season_v1', TTL = 5 * 60 * 1000, MAX = 50;
  var state = {}, pending = {}, applying = false, again = false;
  var BELL = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 10a6 6 0 1 1 12 0c0 4.5 1.6 6 2.5 7H3.5C4.4 16 6 14.5 6 10Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M9.8 20a2.3 2.3 0 0 0 4.4 0" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var LEAF = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 19c0-8 5-13 14-14 0 9-5 14-13 14H5Zm0 0 7-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function day(iso, short) {
    if (!iso) return '';
    try { return new Date(iso + 'T12:00:00Z').toLocaleDateString('en-US', { month: short ? 'short' : 'long', day: 'numeric', timeZone: 'UTC' }); } catch (e) { return iso; }
  }
  function customer() { return String((window.__st && window.__st.cid) || ''); }
  function handleOf(url) { var m = String(url || '').match(/\/products\/([a-z0-9-]+)/i); return m ? m[1].toLowerCase() : ''; }
  function onProductPage() { return /\/products\/[^/]+/.test(location.pathname); }
  function mainHandle() {
    var a = document.querySelector('[data-gllf-product-actions][data-product-handle]:not([data-gllf-season-host])');
    if (a && !a.closest('.card-wrapper, .product-card-wrapper')) return String(a.dataset.productHandle || '').toLowerCase();
    return onProductPage() ? handleOf(location.pathname) : '';
  }
  function cardOf(form) { return form.closest('.card-wrapper, .product-card-wrapper, quick-add-modal, .quick-add-modal'); }
  function handleForForm(form) {
    var card = cardOf(form);
    if (card) { var a = card.querySelector('a[href*="/products/"]'); return a ? handleOf(a.getAttribute('href')) : ''; }
    return onProductPage() ? mainHandle() : '';
  }
  /* Never touch the Great Lakes Deposits order builder / pre-order flows. */
  function ownedByDeposits(form) {
    return !!(form.closest('[data-gllf-lifecycle-owned], [data-gllf-order-builder]') ||
      form.matches('[data-gllf-delivery-approved], [data-gllf-payment-approved]') || form.querySelector('[data-gllf-delivery-gate]'));
  }

  /* ---------- data ---------- */
  function readCache() {
    try { var c = JSON.parse(sessionStorage.getItem(CACHE) || 'null'); if (c && c.cid === customer() && Date.now() - c.at < TTL) return c.products || {}; } catch (e) {}
    return {};
  }
  function writeCache() {
    try { sessionStorage.setItem(CACHE, JSON.stringify({ cid: customer(), at: Date.now(), products: state })); } catch (e) {}
  }
  /* keys are product handles, or "sku:<SKU>" for one option of a combined "All Scents" listing */
  function load(keys) {
    var need = keys.filter(function (k) { return k && !(k in state) && !pending[k]; });
    if (!need.length) return Promise.resolve();
    var batches = [];
    for (var i = 0; i < need.length; i += MAX) batches.push(need.slice(i, i + MAX));
    need.forEach(function (k) { pending[k] = true; });
    return Promise.all(batches.map(function (b) {
      var hs = b.filter(function (k) { return k.indexOf('sku:') !== 0; }), ss = b.filter(function (k) { return k.indexOf('sku:') === 0; }).map(function (k) { return k.slice(4); });
      return fetch(API + '?handles=' + encodeURIComponent(hs.join(',')) + (ss.length ? '&skus=' + encodeURIComponent(ss.join(',')) : ''), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          hs.forEach(function (h) { state[h] = (j && j.products && j.products[h]) || { managed: false, open: true }; });
          ss.forEach(function (s) { state['sku:' + s] = (j && j.variants && j.variants[s]) || { managed: false, open: true }; });
        })
        .catch(function () { /* app unreachable: leave the page exactly as the theme renders it */ })
        .then(function () { b.forEach(function (k) { delete pending[k]; }); });
    })).then(writeCache);
  }
  /* Main product variants (id, sku, title) from Shopify's own page data. Only -MX options are looked up. */
  function mainVariants() {
    var p = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    return p && Array.isArray(p.variants) ? p.variants : [];
  }
  function mxKeys() {
    return mainVariants().filter(function (v) { return /-MX$/i.test(v.sku || ''); }).map(function (v) { return 'sku:' + String(v.sku).toUpperCase(); });
  }
  function variantStatus(form) {
    var id = String((form.querySelector('input[name="id"]') || {}).value || '');
    var v = mainVariants().filter(function (x) { return String(x.id) === id; })[0];
    return v && /-MX$/i.test(v.sku || '') ? state['sku:' + String(v.sku).toUpperCase()] || null : null;
  }
  /* Out-of-season options stay selectable but say when they're back, e.g. "Cherry - back Jul 1". */
  function markOptions() {
    var byValue = {};
    mainVariants().forEach(function (v) {
      if (!/-MX$/i.test(v.sku || '')) return;
      var s = state['sku:' + String(v.sku).toUpperCase()]; if (!s) return;
      var first = String(v.public_title || v.name || '').split(' / ')[0].trim(); if (!first) return;
      var cur = byValue[first] || { closed: true, on: '' };
      if (!(s.managed && !s.open)) cur.closed = false;
      else { var d = s.retailOpensOn || s.opensOn || ''; if (d && (!cur.on || d < cur.on)) cur.on = d; }
      byValue[first] = cur;
    });
    var scope = document.querySelector('variant-selects, variant-radios, .product-form__input'); if (!scope) return;
    var root = scope.closest('product-info, .product__info-wrapper, .shopify-section') || document;
    Object.keys(byValue).forEach(function (value) {
      var info = byValue[value], text = info.closed && info.on ? 'Back ' + day(info.on, true) : '';
      root.querySelectorAll('input[type="radio"]').forEach(function (input) {
        if (input.value !== value) return;
        var label = input.id && root.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]'); if (!label) return;
        var tag = label.querySelector('.gllf-season-opt');
        if (!text) { if (tag) tag.remove(); return; }
        if (!tag) { tag = document.createElement('span'); tag.className = 'gllf-season-opt'; label.appendChild(tag); }
        if (tag.textContent !== text) tag.textContent = text;
      });
      root.querySelectorAll('select option').forEach(function (o) {
        if (o.value !== value) return;
        var base = o.getAttribute('data-gllf-season-base') || o.textContent; o.setAttribute('data-gllf-season-base', base);
        var next = text ? base + ' \u2014 ' + text.toLowerCase() : base; if (o.textContent !== next) o.textContent = next;
      });
    });
  }

  /* ---------- Notify me (Saved & Compare dialog) ---------- */
  function fillHost(host, form, main) {
    var d = host.dataset;
    var appHost = main && document.querySelector('[data-gllf-product-actions]:not([data-gllf-season-host]):not(.gllf-notify-host)');
    if (appHost && !appHost.closest('.card-wrapper, .product-card-wrapper')) {
      Object.keys(appHost.dataset).forEach(function (k) { d[k] = appHost.dataset[k]; });
    } else {
      var card = cardOf(form) || form.parentElement;
      var link = card.querySelector('a[href*="/products/"]');
      var title = card.querySelector('.card__heading a, .card__heading, .product-title, h3, h2');
      var pic = card.querySelector('img');
      var pid = (form.querySelector('input[name="product-id"]') || {}).value || '';
      d.productId = pid; d.productGid = pid ? 'gid://shopify/Product/' + pid : '';
      d.productHandle = link ? handleOf(link.getAttribute('href')) : '';
      d.productTitle = title ? title.textContent.replace(/\s+/g, ' ').trim() : (pic && pic.alt) || '';
      d.productImage = pic ? (pic.currentSrc || pic.src || '') : '';
      d.variantTitle = ''; d.ruleClass = d.ruleClass || 'unknown';
    }
    var vid = (form.querySelector('input[name="id"]') || {}).value || '';
    if (vid) { d.variantId = vid; d.variantGid = 'gid://shopify/ProductVariant/' + vid; }
    d.available = 'false';
  }
  function notifyButton(form, main) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gllf-season__notify' + (main ? ' button button--full-width button--primary' : ' button button--secondary');
    b.setAttribute('data-gllf-alert', '');
    b.setAttribute('aria-haspopup', 'dialog');
    b.innerHTML = BELL + '<span>' + (main ? 'Notify me when it\u2019s back' : 'Notify me') + '</span>';
    b.addEventListener('click', function () {
      var host = b.closest('[data-gllf-season-host]');
      fillHost(host, form, main);
      host.setAttribute('data-gllf-product-actions', '');
      setTimeout(function () { host.removeAttribute('data-gllf-product-actions'); }, 0);
    }, true);
    return b;
  }

  /* ---------- page ---------- */
  function hide(el, on) { if (el) el.classList.toggle('gllf-season-hide', !!on); }
  function scopeOf(form, main) { return main ? (form.closest('product-info, .product__info-wrapper, .shopify-section') || document) : cardOf(form); }
  function badge(scope, s, main) {
    if (!scope) return;
    var closed = s && s.managed && !s.open;
    scope.querySelectorAll(main ? '.price__badge-sold-out' : '.soldout_product_badge, .price__badge-sold-out').forEach(function (b) { hide(b, closed); });
    var mine = scope.querySelector('.gllf-season-badge');
    if (!closed) { if (mine) mine.remove(); return; }
    var text = 'Back ' + day(s.retailOpensOn || s.opensOn, true);
    if (!mine) {
      mine = document.createElement('span');
      mine.className = 'badge gllf-season-badge';
      var spot = main ? scope.querySelector('.wbvariantbadges, .price') : scope.querySelector('.card__badge, .card__media, .card__inner');
      if (!spot) return;
      spot.appendChild(mine);
    }
    if (mine.textContent !== text) mine.textContent = text;
  }
  function note(s) {
    var bucket = (s.buckets && s.buckets[0]) || 'This scent';
    if (!s.open) {
      return '<p class="gllf-season__title">' + LEAF + '<span>Back in season ' + esc(day(s.retailOpensOn || s.opensOn)) + '</span></p>' +
        '<p class="gllf-season__text">' + esc(bucket) + ' is one of our seasonal favorites, made fresh each year. Get an email the day it\u2019s back.</p>';
    }
    if (s.early && s.member) {
      return '<p class="gllf-season__title">' + LEAF + '<span>Lavender Passport early access</span></p>' +
        '<p class="gllf-season__text">Thanks for visiting us at the markets. You can order now; everyone else can from ' + esc(day(s.retailOpensOn)) + '.</p>';
    }
    if (s.early) {
      return '<p class="gllf-season__title">' + LEAF + '<span>Wholesale early access</span></p>' +
        '<p class="gllf-season__text">Stock up now. Retail opens ' + esc(day(s.retailOpensOn)) + (s.closesOn ? ' and the season runs through ' + esc(day(s.closesOn)) : '') + '.</p>';
    }
    return s.closesOn ? '<p class="gllf-season__title gllf-season__title--open">' + LEAF + '<span>' + esc(bucket) + ' season \u00b7 available through ' + esc(day(s.closesOn)) + '</span></p>' : '';
  }
  function applyForm(form) {
    var main = !cardOf(form);
    var info = main ? form.closest('product-info') : null;
    /* v2: a cottage food product's pickup request (.gllf-cf) is closed out of season too */
    var cf = info ? info.querySelector('.gllf-cf') : null;
    if (ownedByDeposits(form) && !cf) return;
    var handle = handleForForm(form); if (!handle) return;
    var s = state[handle]; if (!s) return;
    if (main && !s.managed) { var vs = variantStatus(form); if (vs) s = vs; } /* an All Scents option */
    var add = form.querySelector('button[name="add"]');
    if (!add && !cf) return; /* e.g. the Shop Pay installments form */
    var closed = !!(s.managed && !s.open);
    if (cf) hide(cf, closed);
    var host = (cf ? info : form).querySelector('[data-gllf-season-host]');
    form.toggleAttribute('data-gllf-season-closed', closed);
    hide(add, closed);
    form.querySelectorAll('.gllf-notify-host, .shopify-payment-button, shopify-accelerated-checkout, .product-form__buttons shopify-buy-it-now-button' + (main ? ', .product-form__quantity' : '')).forEach(function (el) { hide(el, closed); });
    badge(scopeOf(form, main), s, main);
    var html = s.managed ? (main ? note(s) : '') : '';
    if (!closed && !html) { if (host) host.remove(); return; }
    if (!host) {
      host = document.createElement('div');
      host.className = 'gllf-season' + (main ? ' gllf-season--main' : ' gllf-season--card');
      host.setAttribute('data-gllf-season-host', '');
      host.setAttribute('role', 'status');
      (cf || add).insertAdjacentElement('beforebegin', host);
    }
    var key = handle + '|' + ((form.querySelector('input[name="id"]') || {}).value || '') + '|' + closed + '|' + (s.opensOn || '') + '|' + (s.closesOn || '') + '|' + !!s.early;
    if (host.dataset.key === key) return;
    host.dataset.key = key;
    host.classList.toggle('gllf-season--closed', closed);
    host.innerHTML = html ? '<div class="gllf-season__note">' + html + '</div>' : '';
    if (closed) host.appendChild(notifyButton(form, main));
    if (main && closed) {
      document.querySelectorAll('[data-gllf-product-actions]:not([data-gllf-season-host]) [data-gllf-alert]').forEach(function (a) {
        if (!a.closest('.card-wrapper, .product-card-wrapper')) a.classList.add('gllf-notify-dup');
      });
    }
  }
  function forms() { return Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]')); }
  function run() {
    if (applying) { again = true; return; }
    applying = true; again = false;
    var list = forms(), handles = {};
    list.forEach(function (f) { var h = handleForForm(f); if (h) handles[h] = true; });
    var main = mainHandle(); if (main) handles[main] = true;
    if (main) mxKeys().forEach(function (k) { handles[k] = true; });
    load(Object.keys(handles)).then(function () {
      list.forEach(function (f) { try { applyForm(f); } catch (e) {} });
      try { markOptions(); } catch (e) {}
    }).then(done, done);
    function done() { setTimeout(function () { applying = false; if (again) soon(); }, 50); }
  }

  /* Belt and braces: an out-of-season retail form can't be submitted even if another script re-shows its button. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && (f.matches('form[action*="/cart/add"][data-gllf-season-closed]') || f.closest('.gllf-season-hide'))) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('form[data-gllf-season-closed] button[name="add"], form[data-gllf-season-closed] .shopify-payment-button button');
    if (b) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  state = readCache();
  var queued = false;
  function soon() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; run(); }); }
  function boot() {
    run();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n && n.closest && n.closest('[data-gllf-season-host]')) continue;
        if (muts[i].addedNodes.length) { soon(); break; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', soon);
  document.addEventListener('change', function (e) { if (e.target.closest('variant-selects, variant-radios, .product-form__input, form[action*="/cart/add"]')) setTimeout(soon, 400); });
  window.GLLFSeasonal = { status: function (h) { return state[String(h || '').toLowerCase()] || null; }, refresh: soon };
})();
